import React from "react";
import "./ProductFeed.scss";
import Product from "./Product";
import { useStateValue } from "../context/StateProvider";

function ProductFeed() {
  const [{ products, category }] = useStateValue();
  return (
    <div className="main">
      <div className="products">
        {products?.map((product) =>
          category === "all" ? (
            <Product id={product.id} item={product} key={product.id} />
          ) : category === product.category ? (
            <Product id={product.id} key={product.id} item={product} />
          ) : null
        )}
      </div>
    </div>
  );
}
export default ProductFeed;
